import { useMemo } from 'react';

interface UseTreeCutModalStateArgs {
    effectiveTreeLayoutKey: string;
    treeScenariosByLayoutKey: Record<string, any[]>;
    singleTreeWithWorthIt: any[];
    multiTreeScenarios: any[];
    baseWattage: number;
    baseMultiplier: number;
    totalModulesBase: number;
    layoutModulesByKey: Record<string, number>;
}

export function useTreeCutModalState({
    effectiveTreeLayoutKey,
    treeScenariosByLayoutKey,
    singleTreeWithWorthIt,
    multiTreeScenarios,
    baseWattage,
    baseMultiplier,
    totalModulesBase,
    layoutModulesByKey,
}: UseTreeCutModalStateArgs) {
    const modalTreeData = useMemo(() => {
        const effectiveKey = effectiveTreeLayoutKey;
        const scenarios = treeScenariosByLayoutKey?.[effectiveKey];
        if (Array.isArray(scenarios) && scenarios.length > 0) {
            const baseW = scenarios[0]?.actualWattage ?? 0;
            const baseMult = scenarios[0]?.systemMultiplier ?? baseMultiplier;
            const baseModulesFromScenarios =
                scenarios[0]?.shadeWeights?.reduce((sum: number, row: any) => sum + (row.moduleCount ?? 0), 0) ??
                totalModulesBase;
            const layoutModulesForKey = layoutModulesByKey?.[effectiveKey];
            const baseModules =
                typeof layoutModulesForKey === 'number' && Number.isFinite(layoutModulesForKey)
                    ? layoutModulesForKey
                    : baseModulesFromScenarios;

           

            const single = scenarios.map((scenario: any) => {
                const isMulti = (scenario.treeIds?.length ?? 0) > 1;
                const gainPct =
                    (scenario.treeId != null || isMulti) && baseW
                        ? (((scenario.actualWattage ?? 0) - baseW) / baseW) * 100
                        : 0;
                const costNum = scenario.cutCost != null ? Number(scenario.cutCost) : NaN;
                const worthIt =
                    (scenario.treeId != null || isMulti) &&
                    gainPct >= 0.1 &&
                    (costNum === 0 || !Number.isFinite(costNum) || gainPct / (costNum / 1000) >= 0.05);
                return { ...scenario, gainPct, costNum, worthIt };
            });
            const multi = scenarios
                .map((scenario: any, index: number) => ({ ...scenario, index }))
                .filter((scenario: any) => scenario.treeIds && scenario.treeIds.length > 1);

            return {
                singleTreeWithWorthIt: single,
                multiTreeScenarios: multi,
                baseWattage: baseW,
                baseMultiplier: baseMult,
                totalModulesBase: baseModules,
            };
        }

        return {
            singleTreeWithWorthIt,
            multiTreeScenarios,
            baseWattage,
            baseMultiplier,
            totalModulesBase,
        };
    }, [
        effectiveTreeLayoutKey,
        treeScenariosByLayoutKey,
        singleTreeWithWorthIt,
        multiTreeScenarios,
        baseWattage,
        baseMultiplier,
        totalModulesBase,
        layoutModulesByKey,
    ]);

    return {
        modalTreeData,
    };
}
